import React, { Children } from 'react';
import { ShieldCheckIcon, LockIcon, CheckIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function ProblemSection() {
  const handleCheckout = () => {
    trackAddToCart();
    window.open('https://apuestasinteligentes.com/cart/47692107743453:1', '_blank', 'noopener,noreferrer');
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="comprar" className="w-full py-24 px-4 bg-brand-alt border-y border-brand-card relative overflow-hidden" data-id="element-148">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-149" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-4xl md:text-5xl text-brand-text font-heading mb-4" data-id="element-152">
            Elige cómo quieres empezar con BetIQ hoy
          </h2>
          <p className="text-lg md:text-xl text-brand-muted" data-id="element-153">
            Acceso inmediato • Sin suscripciones • Cupos limitados
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center mb-12" data-id="element-154">
          {/* Card 1: Basic */}
          <motion.div id="basico" variants={cardVariants} className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 flex flex-col h-full relative" data-id="element-155">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-card border border-brand-gold/20 text-brand-gold/70 font-bold px-4 py-1 rounded-full text-sm tracking-wide" data-id="element-156">
              BÁSICO
            </div>

            <div className="mb-6 mt-2" data-id="element-157">
              <h3 className="text-xl font-bold mb-2" data-id="element-158">
                <span className="text-brand-gold" data-id="element-159">Solo Método</span>{' '}
                <span className="text-brand-gold" data-id="element-160">(</span>
                <span className="text-brand-text" data-id="element-161">Sin BetIQ</span>
                <span className="text-brand-gold" data-id="element-162">)</span>
              </h3>
              <div className="flex items-end gap-2 mb-4" data-id="element-163">
                <span className="text-brand-muted line-through text-lg" data-id="element-164">
                  $12.99
                </span>
                <span className="text-4xl font-heading font-bold text-brand-text" data-id="element-165">
                  $9.99
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-166">
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-167">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-168" />
                <span data-id="element-169">Método paso a paso</span>
              </li>
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-170">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-171" />
                <span data-id="element-172">Aprende a analizar partidos</span>
              </li>
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-173">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-174" />
                <span data-id="element-175">Ideal para empezar desde cero</span>
              </li>
              <li className="flex items-start gap-3 text-brand-faint" data-id="element-176">
                <XIcon className="w-5 h-5 text-brand-red/70 shrink-0 mt-0.5" data-id="element-177" />
                <span data-id="element-178">Sin acceso a BetIQ</span>
              </li>
            </ul>

            <button onClick={handleCheckout} className="w-full py-3 px-6 rounded-md border border-brand-gold/30 text-brand-gold font-bold hover:bg-brand-gold/10 transition-colors" data-id="element-179">
              Empezar solo con el método
            </button>
          </motion.div>

          {/* Card 2: Recommended */}
          <motion.div id="recomendado" variants={cardVariants} className="bg-brand-card border-2 border-brand-gold rounded-2xl p-8 flex flex-col h-full relative shadow-[0_0_30px_rgba(212,168,67,0.3)] lg:scale-105 z-10" data-id="element-180">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-bg font-bold px-4 py-1 rounded-full text-sm tracking-wide" data-id="element-181">
              RECOMENDADO
            </div>

            <div className="mb-6 mt-2" data-id="element-182">
              <h3 className="text-2xl text-brand-gold font-bold mb-2" data-id="element-183">
                BetIQ + Método (5 días de acceso)
              </h3>
              <div className="flex items-end gap-2 mb-1" data-id="element-184">
                <span className="text-brand-muted line-through text-lg" data-id="element-185">
                  $17.99
                </span>
                <span className="text-5xl font-heading font-bold text-brand-gold" data-id="element-186">
                  $14.99
                </span>
              </div>
              <p className="text-brand-green text-sm font-medium" data-id="element-187">
                Menos de $3 por día
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-188">
              <li className="flex items-start gap-3 text-brand-text" data-id="element-189">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-190" />
                <span className="font-medium" data-id="element-191">Acceso a BetIQ (por 5 días)</span>
              </li>
              <li className="flex items-start gap-3 text-brand-text" data-id="element-192">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-193" />
                <span data-id="element-194">Método completo incluido</span>
              </li>
              <li className="flex items-start gap-3 text-brand-text" data-id="element-195">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-196" />
                <span data-id="element-197">Bonos incluidos</span>
              </li>
              <li className="flex items-start gap-3 text-brand-text" data-id="element-198">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-199" />
                <span data-id="element-200">Empiezas hoy mismo</span>
              </li>
            </ul>

            <button onClick={() => {
            trackAddToCart();
            window.open('https://apuestasinteligentes.com/cart/47728150347997:1', '_blank', 'noopener,noreferrer');
          }} className="w-full py-4 px-6 rounded-md bg-brand-gold text-brand-bg font-bold text-lg hover:scale-105 hover:shadow-[0_0_20px_rgba(212,168,67,0.4)] transition-all duration-300" data-id="element-201">
              👉 Quiero probar BetIQ
            </button>
          </motion.div>

          {/* Card 3: Premium */}
          <motion.div variants={cardVariants} className="bg-brand-card border border-brand-gold/30 rounded-2xl p-8 flex flex-col h-full relative" data-id="element-202">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-card border border-brand-gold/30 text-brand-gold/70 font-bold px-4 py-1 rounded-full text-sm tracking-wide" data-id="element-203">
              ILIMITADO
            </div>

            <div className="mb-6 mt-2" data-id="element-204">
              <h3 className="text-xl text-brand-text font-bold mb-2" data-id="element-205">
                BetIQ Completo + Método (Acceso ilimitado)
              </h3>
              <div className="flex items-end gap-2 mb-1" data-id="element-206">
                <span className="text-4xl font-heading font-bold text-brand-text" data-id="element-207">
                  $27
                </span>
              </div>
              <p className="text-brand-muted text-sm" data-id="element-208">Pago único</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-209">
              <li className="flex items-start gap-3 text-brand-text" data-id="element-210">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-211" />
                <span className="font-medium" data-id="element-212">Acceso completo a BetIQ</span>
              </li>
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-213">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-214" />
                <span data-id="element-215">Método + bonos incluidos</span>
              </li>
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-216">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-217" />
                <span data-id="element-218">Sin límite de tiempo</span>
              </li>
              <li className="flex items-start gap-3 text-brand-muted" data-id="element-219">
                <CheckIcon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-220" />
                <span data-id="element-221">Mejor valor a largo plazo</span>
              </li>
            </ul>

            <button onClick={() => {
            trackAddToCart();
            window.open('https://apuestasinteligentes.com/cart/47728154902749:1', '_blank', 'noopener,noreferrer');
          }} className="w-full py-3 px-6 rounded-md border-2 border-brand-gold/50 text-brand-text font-bold hover:bg-brand-gold/20 transition-colors" data-id="element-222">
              Acceso completo a BetIQ
            </button>
          </motion.div>
        </motion.div>

        {/* Upgrade section for existing method owners */}
        <div className="max-w-lg mx-auto mt-10 mb-12 bg-brand-bg/50 border border-dashed border-brand-gold/20 rounded-xl p-6 text-center space-y-4" data-id="element-223">
          <h3 className="text-xl text-brand-muted font-bold" data-id="element-224">
            ¿Ya tienes el método?
          </h3>
          <p className="text-brand-muted text-sm max-w-md mx-auto" data-id="element-225">
            Si ya compraste el método básico, ahora puedes activar el acceso a
            la plataforma BetIQ y empezar a aplicarlo en partidos reales.
          </p>
          <p className="text-brand-gold font-bold text-lg" data-id="element-226">
            Acceso a BetIQ por solo{' '}
            <span className="line-through text-brand-muted text-base font-normal" data-id="element-227">
              $17 USD
            </span>{' '}
            <span className="text-2xl font-extrabold text-brand-gold" data-id="element-228">
              $9.99 USD
            </span>
          </p>
          <p className="text-brand-faint text-xs mt-1" data-id="element-229">
            ⏳ Precio de introducción por tiempo limitado
          </p>
          <button onClick={() => {
          trackAddToCart();
          window.open('https://apuestasinteligentes.com/cart/47727551545565:1', '_blank', 'noopener,noreferrer');
        }} className="px-8 py-2.5 rounded-md border border-brand-gold/40 text-brand-gold font-bold text-sm hover:bg-brand-gold/10 transition-colors" data-id="element-230">
            Activar BetIQ
          </button>
          <p className="text-brand-faint text-xs" data-id="element-231">
            Acceso inmediato • Usuario y contraseña • Sin suscripciones
          </p>
        </div>

        <p className="text-center text-brand-muted italic mb-4" data-id="element-232">
          "Empieza con el método… o accede al sistema completo BetIQ desde hoy"
        </p>
        <div className="text-center mb-16 space-y-1" data-id="element-233">
          <p className="text-brand-text text-sm font-medium" data-id="element-234">
            👉 Compatible con todos tus dispositivos
          </p>
          <p className="text-brand-muted text-sm" data-id="element-235">
            💻 Laptop • 🖥️ PC • 📱 Móvil • 📲 Tablet
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-6" data-id="element-236">
          {/* Guarantee Block */}
          <div className="bg-brand-bg border border-brand-gold/20 rounded-xl p-6 text-left space-y-4 relative overflow-hidden" data-id="element-237">
            <div className="absolute -right-4 -top-4 opacity-10" data-id="element-238">
              <ShieldCheckIcon className="w-24 h-24 text-brand-gold" data-id="element-239" />
            </div>
            <h3 className="text-2xl text-brand-text font-bold relative z-10" data-id="element-240">
              ¿Qué pasa si no es para ti?
            </h3>
            <p className="text-brand-gold font-bold text-xl relative z-10" data-id="element-241">
              No arriesgas nada.
            </p>
            <div className="space-y-3 relative z-10" data-id="element-242">
              <p className="text-brand-muted" data-id="element-243">
                Prueba BetIQ. Si en los próximos 7 días sientes que no es para
                ti, solo escríbeme y te devuelvo tu dinero.
              </p>
              <p className="text-brand-muted font-medium" data-id="element-244">
                Sin preguntas. Sin procesos complicados. Sin riesgo.
              </p>
              <p className="text-brand-text italic" data-id="element-245">
                Porque esto no es para convencerte… es para que lo pruebes.
              </p>
            </div>
          </div>

          {/* Scarcity Block */}
          <div className="border border-brand-red/30 bg-brand-red/5 rounded-xl p-6 text-left space-y-3" data-id="element-246">
            <h3 className="text-brand-red font-bold flex items-center gap-2" data-id="element-247">
              <span className="text-xl" data-id="element-248">⚠️</span> Aviso de lanzamiento
            </h3>
            <div className="space-y-2" data-id="element-249">
              <p className="text-brand-muted text-sm" data-id="element-250">
                Este precio es temporal.
              </p>
              <p className="text-brand-muted text-sm" data-id="element-251">
                Cuando termine el lanzamiento, el acceso a BetIQ sube de precio
                y los bonos desaparecen.
              </p>
              <p className="text-brand-text text-sm font-medium" data-id="element-252">
                Si estás viendo esto ahora, todavía estás a tiempo.
              </p>
            </div>
          </div>

          {/* Trust Line */}
          <div className="flex items-center justify-center gap-4 flex-wrap pt-4" data-id="element-253">
            <span className="flex items-center gap-1.5 text-brand-muted text-sm" data-id="element-254">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-255" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5 text-brand-muted text-sm" data-id="element-256">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-257" />
              Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5 text-brand-muted text-sm" data-id="element-258">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-259" />
              Sin suscripciones
            </span>
          </div>
        </div>
      </div>
    </section>;
}